import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { OturumSiniri } from "./oturum-siniri";
import { Uygulama } from "./Uygulama";
import { TarayiciDesteklenmiyor } from "./SistemSayfalari";
import { tarayiciYetenekleri } from "./tarayici-destegi";
import "./stil.css";

const sorguIstemcisi = new QueryClient({
  defaultOptions: {
    queries: {
      // Panel CEVRIMDISI CALISMAZ ve calismamalidir: yonetim islemleri
      // kuyruga alinmaz. Cevrimdisi davranis yalnizca ogrenci uygulamasinda.
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,

      /**
       * ================================================================
       * BAGLANTIYI BEKLEYIP SUSMA — HATA VER
       * ================================================================
       * Varsayilan (`networkMode: "online"`) baglanti kesik gorundugunde
       * sorguyu DURAKLATIR: durum `pending` kalir, ekran "Yukleniyor…"
       * yazar ve kullaniciya hicbir sey soylenmez. Panel zaten
       * cevrimdisi calismayacagini soyluyor (yukaridaki not); oyleyse
       * sessizce beklemek yanlis davranis — sorgu BASARISIZ olmali ve
       * ekran "baglanti yok" diye konusmali. Sessiz bir bekleme,
       * kullaniciya sistemin bozuldugunu dusundurur.
       *
       * NOT (02.08.2026): bu ayar SEKME ARKA PLANDAYKEN olan duraklamayi
       * engellemez — React Query yeniden denemeleri odak yokken
       * `networkMode`'dan BAGIMSIZ olarak duraklatir. O bir hata degil,
       * kutuphanenin tasarimi; gercek kullanici odakli oldugu icin
       * gormez. Yalnizca tarayici otomasyonuyla dogrulama yaparken
       * karsina cikar (bkz. BASLA.md "Ortamla ilgili tekrar eden
       * takilmalar").
       */
      networkMode: "always",
    },
    // Yazma islemleri de ayni sebeple duraklatilmiyor: bir kayit
    // dugmesine basip hicbir sey olmamasi, hata almaktan kotudur.
    mutations: { networkMode: "always" },
  },
});

const kok = document.getElementById("kok");
if (!kok) throw new Error("#kok bulunamadi");

/*
  ================================================================
  TARAYICI KONTROLÜ UYGULAMADAN ÖNCE
  ================================================================
  Kontrolü `Uygulama` içine koysaydık, arayüzü çizemeyen bir
  tarayıcıda önce bütün ağaç kurulur, sonra "desteklenmiyor" denirdi
  — ve o ağaç kurulurken zaten patlayabilir.

  Yetenek ölçülüyor, SÜRÜM NUMARASI okunmuyor: `userAgent` ayıklamak
  her yeni tarayıcı sürümünde eskiyen bir liste demek ve yanlış
  eşleşen bir kural ÇALIŞAN bir tarayıcıyı engeller.
*/
const yetenek = tarayiciYetenekleri(window);

createRoot(kok).render(
  <StrictMode>
    {yetenek.destekli ? (
      <QueryClientProvider client={sorguIstemcisi}>
        <OturumSiniri>
          <Uygulama />
        </OturumSiniri>
      </QueryClientProvider>
    ) : (
      // Sorgu sağlayıcısı BİLEREK yok: bu ekran hiçbir istek atmıyor
      // ve atamamalı — tarayıcı zaten arayüzü çizemiyor.
      <TarayiciDesteklenmiyor />
    )}
  </StrictMode>,
);
